import type { ErrorSeverity } from '@gonfalon/telemetry/types';

/**
 * Derives an error severity from an HTTP status code.
 * 5xx (server errors) → medium
 * 4xx (client errors) → low
 */
export function getHTTPStatusSeverity(status: number): ErrorSeverity {
  if (status >= 500) {
    return 'medium';
  }

  return 'low';
}
